import React, { useEffect, useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
import HoursOfOperationForm from './HoursOfOperationForm';
import { toast } from 'react-toastify';
import Loading from '../../../../common/Loading';
const HoursOfOperation = () => {
    const [loading, setLoading] = useState(true);
    const { clinicId } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [hours, setHours] = useState([]);

    useEffect(() => {
        setLoading(true);
        clinicService
            .getHours(clinicId)
            .then((hours) => {
                setHours(hours.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error('Error while retrieving hours of operation', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    }, [clinicId]);

    const handleSave = (savedHours) => {
        setHours(savedHours);
        setIsEditing(false);
        toast.success('Hours updated successfully!', {
            position: toast.POSITION.BOTTOM_RIGHT,
        });
    };

    const cancelEditing = () => {
        setIsEditing(false);
    };

    const openDays = hours.filter((hour) => hour.status).length;

    return (
        <>
            <div className="d-flex align-items-end justify-content-between gap-2 mb-3">
                <div>
                    <h5 className="clinic-hours__title mb-1">
                        <i className="bi bi-clock text-primary me-1"></i>
                        Hours of Operation
                        {!loading && hours.length > 0 && (
                            <span className="clinic-hours__count">
                                ({openDays} open / {hours.length} day{hours.length !== 1 ? 's' : ''})
                            </span>
                        )}
                    </h5>
                    <p className="text-muted small mb-0">Weekly schedule, open/closed status, and notes per day.</p>
                </div>
                {!loading && hours.length > 0 && !isEditing && (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm flex-shrink-0"
                        onClick={() => setIsEditing(true)}
                    >
                        <i className="bi bi-pencil-square me-1"></i>
                        Edit Hours
                    </button>
                )}
            </div>

            {loading ? (
                <Loading />
            ) : isEditing ? (
                <HoursOfOperationForm
                    key={hours.map((h) => h.id).join('-')}
                    hours={hours}
                    onSave={handleSave}
                    onCancel={cancelEditing}
                />
            ) : hours.length === 0 ? (
                <div className="clinic-hours-empty">
                    <i className="bi bi-clock"></i>
                    No hours of operation configured.
                </div>
            ) : (
                <>
                    <div className="clinic-hours-toolbar">
                        <div>
                            <strong>{openDays}</strong> open · <strong>{hours.length - openDays}</strong> closed
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle mb-0 process-queue-table clinic-hours-table">
                            <thead>
                                <tr>
                                    <th>
                                        <i className="bi bi-calendar3"></i> Day
                                    </th>
                                    <th>
                                        <i className="bi bi-watch"></i> Operating Hours
                                    </th>
                                    <th>
                                        <i className="bi bi-toggle-on"></i> Status
                                    </th>
                                    <th>
                                        <i className="bi bi-sticky"></i> Notes
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {hours.map((hour) => (
                                    <tr
                                        key={hour.id}
                                        className={`clinic-hours-row ${!hour.status ? 'clinic-hours-row--closed' : ''}`}
                                    >
                                        <td>
                                            <span className="clinic-hours-day">{hour.day}</span>
                                        </td>
                                        <td>
                                            {hour.status ? (
                                                <span className="clinic-hours-time">
                                                    <i className="bi bi-clock"></i>
                                                    {hour.start} – {hour.end}
                                                </span>
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </td>
                                        <td>
                                            <span
                                                className={`clinic-hours-status-badge ${
                                                    hour.status
                                                        ? 'clinic-hours-status-badge--open'
                                                        : 'clinic-hours-status-badge--closed'
                                                }`}
                                            >
                                                {hour.status ? 'Open' : 'Closed'}
                                            </span>
                                        </td>
                                        <td>
                                            {hour.note ? (
                                                <span className="clinic-hours-note">{hour.note}</span>
                                            ) : (
                                                <span className="clinic-hours-note clinic-hours-note--empty">No notes</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
};

export default HoursOfOperation;
